import { Routes, RouterModule } from '@angular/router';
import { PermissionManagementComponent } from './components/permission-management/permission-management.component';

const routes: Routes = [
    { path: 'manage-permission', component: PermissionManagementComponent }
];

export const PermissionRouting = RouterModule.forChild(routes);
